import {Request} from '@group-devs/yfp7-global-modules'
import {Nav, NavDropdown, Image, Row, Col} from 'react-bootstrap'
import {FaChevronDown} from "react-icons/fa"
import {YourGuideNav, CommunityNav, BStartNav} from '@group-devs/yfp7-global-modules/components/Block'
import navStyles from '@group-devs/yfp7-global-modules/components/topnav.module.css'
import Link from 'next/link' 

const request = new Request(process.env.apiDomain)

function WMemDropdownNav(props) {
   
    const accountId = props.site.site.accountId;
    const userId = props.site.auth.userId;

    const {data: wellness} = request.website.swrSite(props.site.site.accountId, "WC");
    const {data: profile} = request.account.swrAccountProfile(accountId);

    return (
        <div className="member-dropdown leftNav d-lg-block d-none mt-1">
            <NavDropdown title={<div><Image src={profile ? profile.avatar : '/images/profile-default.jpg'} width={45} height={45} className="mr-3" roundedCircle /> {profile ? profile.first_name : ''} <FaChevronDown size={11}/></div>} className={navStyles.logoToggle}>
                <Row>
                    <Col xl={3} lg={4} className="bg-lighter-gray text-lg-center text-left py-lg-3 py-2 pr-lg-0 pr-3">
                        <YourGuideNav site={props.site.site}/>
                    </Col>
                    <Col className="text-center d-flex pt-3">
                        <CommunityNav site={props.site.site} />
                    </Col>
                </Row>
            </NavDropdown>
        </div>
    )
}

export default WMemDropdownNav
